import {Forms} from '../../forms/Forms';
import {ErrorHandlerInterface} from './ErrorHandlerInterface';

export class PHPSendLogsHandler implements ErrorHandlerInterface {

    SERVICE_ERRORHANDLER = '../../onlinecommon/web/logHandler.php';

    private message: string;

    constructor() {}

    public init(message: string): void {
        this.message = message;
        this.send();
    }

    private getFullMessage(): string {
        let message = this.message;
        if (document.readyState) {
            message += '\nDocument Status: ' + document.readyState;
        }
        if (window.location) {
            message += '\nlocation: ' + window.location;
        }
        return message;
    }

    private send(): void {
        Forms.ajax(this.SERVICE_ERRORHANDLER, {message: this.getFullMessage()});
    }

}